import React from "react";
import styled from "styled-components";
import { graphql } from "gatsby";

import BaseHeader from "./base";
import ContentModal from "Components/common/base/contentModal";

const StyledContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  padding: 1rem;
  ${(props) => props.theme.responsive.desktop} {
    width: 45%;
  }
`;

export default function BlurbHeader({ content, ...props }) {
  return (
    <BaseHeader {...props}>
      <StyledContentWrapper>
        <ContentModal {...content} />
      </StyledContentWrapper>
    </BaseHeader>
  );
}

export const query = graphql`
  fragment blurbHeaderModal on STRAPI_ComponentHeaderBlurbHeader {
    __typename
    id
    content {
      subtitle {
        en
        es
        it
      }
      title {
        en
        es
        it
      }
      content {
        en
        es
        it
      }
      ctas {
        label {
          en
          es
          it
        }
        link
        type
      }
    }
    textColor {
      color
    }
    backgroundColor {
      color
    }
    backgroundAsset {
      desktop {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: AUTO
              layout: FULL_WIDTH
              quality: 100
            )
          }
        }
      }
      mobile {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: AUTO
              layout: FULL_WIDTH
              quality: 100
            )
          }
        }
      }
    }
    vimeoURL
  }
`;
